import * as TYPES from '@app/store/actionTypes';
import AllowSignatureTypes from '@app/store/AllowSignatureTypes';
import FieldType from '@app/store/FieldType';
import { TemplateAction } from '@app/store/template/actions';

export type TemplateFieldTarget =
  | {
      participantId: string;
      type: FieldType.CHECKBOX_GROUP | FieldType.TEXT_FIELD;
    }
  | {
      allowSignatureTypes: AllowSignatureTypes;
      participantId: string;
      type: FieldType.SIGNATURE_FIELD;
    };

export type TemplateFieldTargetState = TemplateFieldTarget | null;

const initialState: TemplateFieldTargetState = null;

export default function reducer(
  state: TemplateFieldTargetState = initialState,
  action: TemplateAction
): TemplateFieldTargetState {
  switch (action.type) {
    case TYPES.TEMPLATE_CLEAR_ALL_STATE:
    case TYPES.TEMPLATE__FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE:
    case TYPES.TEMPLATE_INFORMATION_FETCH_REQUEST:
    case TYPES.TEMPLATE_FIELD__CREATION_CANCEL:
      return initialState;
    case TYPES.TEMPLATE_FIELD_TARGET_SET:
      return action.payload;
    case TYPES.TEMPLATE_FIELD__ALLOW_SIGNATURE_TYPES_SELECT: {
      if (state?.type === FieldType.SIGNATURE_FIELD) {
        return {
          ...state,
          allowSignatureTypes: action.payload.allowSignatureTypes,
        };
      }
      return state;
    }
    default:
      return state;
  }
}
